import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen font-sans" style={{ backgroundColor: "#FEF7EB" }}>
      <Navbar />
 <section className="pt-40 pb-24 px-6 md:px-16">
        <div className="max-w-3xl mx-auto">
          <p className="text-xs font-semibold uppercase tracking-widest mb-4" style={{ color: "#0073E5" }}>Legal</p>
          <h1 className="text-4xl md:text-5xl font-bold text-black mb-8">Privacy Policy</h1>
          <p className="text-sm text-gray-400 mb-10">Last updated: April 14, 2026</p>
          <div className="space-y-8 text-gray-600 text-sm leading-relaxed">
 
            <div>
              <h2 className="text-lg font-bold text-black mb-3">1. Introduction</h2>
              <p>
                This Privacy Policy explains how London App Syndicate LTD ("Company", "we", "our", or "us")
                collects, uses, stores, and protects personal data when you use this website (the "Site") and any
                related services (collectively, the "Services").
              </p>
              <p className="font-bold mt-3">Registered Office:</p>
              <p>London App Syndicate LTD</p>
              <p>International House</p>
              <p>22-28 Wood Street</p>
              <p>Doncaster</p>
              <p>England</p>
              <p>DN1 3LW</p>
              <p className="font-bold mt-3">Contact Information:</p>
              <p>Email: support@londonappsco.com</p>
              <p>Phone: +447520663996</p>
              <p className="mt-3">
                We are committed to protecting your privacy and handling your personal data in accordance
                with applicable data protection laws, including the UK GDPR.
              </p>
              <p className="mt-2">
                By using the Site, you acknowledge that you have read and understood this Privacy Policy.
              </p>
            </div>
 
            <div>
              <h2 className="text-lg font-bold text-black mb-3">2. Information We Collect</h2>
              <p>We may collect the following categories of information:</p>
              <p className="font-bold mt-3">a. Personal Information</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number (if provided)</li>
                <li>Any information you submit via forms or communications</li>
              </ul>
              <p className="font-bold mt-3">b. Technical and Usage Data</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>IP address</li>
                <li>Browser type and version</li>
                <li>Device type and operating system</li>
                <li>Pages visited and interaction data</li>
                <li>Date and time of access</li>
              </ul>
              <p className="font-bold mt-3">c. Communication Data</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Messages sent through contact forms or email</li>
                <li>Support requests and related correspondence</li>
              </ul>
              <p className="font-bold mt-3">d. Cookies and Tracking Technologies</p>
              <p className="mt-1">
                We use cookies and similar technologies to improve functionality and user experience. See
                Section 9 for details.
              </p>
            </div>
 
            <div>
              <h2 className="text-lg font-bold text-black mb-3">3. How We Use Your Information</h2>
              <p>We use your data for the following purposes:</p>
              <p className="font-bold mt-3">a. Providing Services</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Responding to inquiries and requests</li>
                <li>Operating and maintaining the Site</li>
                <li>Delivering requested information or services</li>
              </ul>
              <p className="font-bold mt-3">b. Improving the Site</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Analyzing usage and performance</li>
                <li>Enhancing functionality and user experience</li>
              </ul>
              <p className="font-bold mt-3">c. Communication</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Sending responses, updates, or important notices</li>
                <li>Providing support</li>
              </ul>
              <p className="font-bold mt-3">d. Legal Compliance</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Complying with legal obligations</li>
                <li>Preventing fraud or misuse</li>
                <li>Enforcing our Terms of Use</li>
              </ul>
              <p className="font-bold mt-3">e. Marketing (if applicable)</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Sending updates or promotional content (only with your consent)</li>
                <li>You may opt out at any time</li>
              </ul>
            </div>
 
            <div>
              <h2 className="text-lg font-bold text-black mb-3">4. Legal Basis for Processing</h2>
              <p>We process personal data based on:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Consent — where you have provided it</li>
                <li>Legitimate Interests — to operate and improve our services</li>
                <li>Legal Obligations — where required by law</li>
                <li>Contractual Necessity — where processing is required to respond to your request</li>
              </ul>
            </div>
 
            <div>
              <h2 className="text-lg font-bold text-black mb-3">5. Sharing of Information</h2>
              <p>We may share your data with:</p>
              <p className="font-bold mt-3">a. Service Providers</p>
              <p className="mt-1">Third-party providers who assist with:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Website hosting</li>
                <li>Email communication</li>
                <li>Analytics</li>
              </ul>
              <p className="mt-2">These providers are required to protect your data and use it only for specified purposes.</p>
              <p className="font-bold mt-3">b. Legal Requirements</p>
              <p className="mt-1">We may disclose information if required by law or to protect rights, safety, or property.</p>
              <p className="font-bold mt-3">c. Business Transfers</p>
              <p className="mt-1">
                In the event of a merger or sale, data may be transferred to a new entity under similar protections.
              </p>
              <p className="font-bold mt-3">d. With Your Consent</p>
              <p className="mt-1">We may share data where you explicitly agree.</p>
              <p className="mt-2">We do not sell personal data.</p>
            </div>
 
            <div>
              <h2 className="text-lg font-bold text-black mb-3">6. Data Retention</h2>
              <p>We retain personal data only as long as necessary to:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Fulfill the purposes described in this Policy</li>
                <li>Comply with legal obligations</li>
                <li>Resolve disputes</li>
              </ul>
              <p className="mt-2">Retention periods vary depending on the type of data.</p>
            </div>
 
            <div>
              <h2 className="text-lg font-bold text-black mb-3">7. Data Security</h2>
              <p>We implement appropriate technical and organizational measures, including:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Secure data storage and transmission</li>
                <li>Access controls</li>
                <li>Monitoring and protection against unauthorized access</li>
              </ul>
              <p className="mt-2">However, no system is completely secure, and we cannot guarantee absolute security.</p>
            </div>
 
            <div>
              <h2 className="text-lg font-bold text-black mb-3">8. Your Rights</h2>
              <p>Under applicable data protection laws, you have the right to:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Access your personal data</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Restrict processing in certain cases</li>
                <li>Object to processing</li>
                <li>Request data portability</li>
              </ul>
              <p className="mt-2">
                To exercise your rights, contact:{" "}
                <a href="mailto:support@londonappsco.com" className="underline cursor-pointer">
                  support@londonappsco.com
                </a>
              </p>
            </div>
 
            <div>
              <h2 className="text-lg font-bold text-black mb-3">9. Cookies</h2>
              <p>We use cookies to improve functionality and user experience.</p>
              <p className="mt-2">Types of cookies we use:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Essential – required for operation of the Site</li>
                <li>Analytics – help us understand usage</li>
                <li>Functional – remember preferences</li>
              </ul>
              <p className="mt-2">You can manage or disable cookies through your browser settings.</p>
            </div>
 
            <div>
              <h2 className="text-lg font-bold text-black mb-3">10. International Data Transfers</h2>
              <p>Your data may be processed outside your country of residence.</p>
              <p className="mt-2">
                Where required, we ensure appropriate safeguards are in place in accordance with applicable laws.
              </p>
            </div>
 
            <div>
              <h2 className="text-lg font-bold text-black mb-3">11. Children's Privacy</h2>
              <p>The Site is not intended for individuals under the age of 16.</p>
              <p className="mt-2">
                We do not knowingly collect personal data from children. If we become aware of such data, we
                will delete it.
              </p>
            </div>
 
            <div>
              <h2 className="text-lg font-bold text-black mb-3">12. Changes to this Privacy Policy</h2>
              <p>We may update this Privacy Policy from time to time.</p>
              <p className="mt-2">
                Updates will be posted on this page with a revised effective date. Continued use of the Site
                constitutes acceptance of the updated Policy.
              </p>
            </div>
 
            <div>
              <h2 className="text-lg font-bold text-black mb-3">13. Contact Information</h2>
              <p className="font-bold">Registered Office:</p>
              <p>London App Syndicate LTD</p>
              <p>International House</p>
              <p>22-28 Wood Street</p>
              <p>Doncaster</p>
              <p>England</p>
              <p>DN1 3LW</p>
              <p className="font-bold mt-3">Contact Information:</p>
              <p>Email: support@londonappsco.com</p>
              <p>Phone: +447520663996</p>
            </div>
 
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
